// Ray-casting point-in-polygon for territory assignment (T-GEO-002).
// Accepts polygon vertices as {lat,lng} maps (Firestore shape, DoR-27a) or
// [lat,lng] tuples; point as [lat,lng] or {lat,lng}.

function asLatLng(v) {
  return Array.isArray(v) ? { lat: v[0], lng: v[1] } : v;
}

export function pointInPolygon(point, polygon) {
  const p = asLatLng(point);
  const pts = (polygon || []).map(asLatLng);
  if (pts.length < 3) return false;
  let inside = false;
  // Treat lng as x, lat as y.
  for (let i = 0, j = pts.length - 1; i < pts.length; j = i++) {
    const xi = pts[i].lng;
    const yi = pts[i].lat;
    const xj = pts[j].lng;
    const yj = pts[j].lat;
    const intersect =
      (yi > p.lat) !== (yj > p.lat) &&
      p.lng < ((xj - xi) * (p.lat - yi)) / (yj - yi) + xi;
    if (intersect) inside = !inside;
  }
  return inside;
}

// territories: [{ id, polygon }]. Returns the first containing territory id, or null.
export function assignTerritory(point, territories) {
  for (const t of territories || []) {
    if (pointInPolygon(point, t.polygon)) return t.id;
  }
  return null;
}
